import { Component, inject, input, InputSignal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseObjOutputDialogInterface } from '@shared/library/configs/interfaces/base-obj-data-output-dialog-interface';
import { ConfigCleanFiltersInterface } from '@shared/library/configs/interfaces/config-functions-interface';
import { AlertConfirmInterface } from '@shared/library/configs/interfaces/alert-confirm-interface';
import { CloseDialogModalEnum } from '@shared/library/configs/enums/close-dialog-modal-enum';
import { TypeDialogEnum } from '@shared/library/configs/enums/type-dialog-enum';
import { BaseUtilities } from '@shared/library/configs/helpers/base-utilities';
import { TypeEpEnum } from '@domain/interfaces/ep-type';

import { MatButtonModule } from '@angular/material/button';

import { 
  MAT_DIALOG_DATA, 
  MatDialogContent, 
  MatDialogActions,
  MatDialogModule, 
  MatDialogTitle, 
  MatDialogRef
} from '@angular/material/dialog';

const MaterialModules = [ 
  MatDialogActions, 
  MatDialogContent,
  MatButtonModule, 
  MatDialogModule, 
  MatButtonModule, 
  MatDialogTitle
];

@Component({
  selector: 'app-base-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModules],
  templateUrl: './base-dialog.component.html',
  styleUrl: './base-dialog.component.scss'
})
export class BaseDialogComponent implements OnInit {
  public title: InputSignal<string | undefined> = input<string | undefined>();
  public label: InputSignal<string | undefined> = input<string | undefined>();
  public type: InputSignal<TypeDialogEnum> = input.required<TypeDialogEnum>();
  public headerClass: InputSignal<string | undefined> = input<string | undefined>();
  public labelButtonSuccess: InputSignal<string> = input<string>( 'Confirmar' );
  public labelButtonCancel: InputSignal<string> = input<string>( 'Cancelar' );
  public editData: InputSignal<any | undefined> = input<any | undefined>();
  /** Si se provee, se invoca al aceptar (FORM) para obtener los datos actuales en lugar de editData. */
  public getEditData: InputSignal<(() => any) | undefined> = input<(() => any) | undefined>();
  public buttonTertiary: InputSignal<ConfigCleanFiltersInterface | undefined> = input<ConfigCleanFiltersInterface | undefined>();
  public isLabel: InputSignal<boolean> = input<boolean>( false );
  public isButtonsDialog: InputSignal<boolean> = input<boolean>( true );
  public isButtonCancel: InputSignal<boolean> = input<boolean>( true );
  public isButtonSuccess: InputSignal<boolean> = input<boolean>( true );
  public disabledButtonOk: InputSignal<boolean> = input<boolean>( false );
  
  public urlImgError: string = '';
  public isBaseButtonsDialog: boolean = false;
  public subTypeDialog!: TypeEpEnum;

  private readonly data = inject( MAT_DIALOG_DATA );
  private readonly dialogRef: MatDialogRef<any, any> = inject( MatDialogRef<any> );

  public dataDialog: AlertConfirmInterface | undefined;
  public objDataOutput!: BaseObjOutputDialogInterface;
  
  ngOnInit(): void {
    this.dataDialog = this.data;
    this.isBaseButtonsDialog = this.dataDialog?.isButtons ?? this.isButtonsDialog();
    this.subTypeDialog = this.dataDialog?.subType ?? (this.dataDialog ? TypeEpEnum.EDIT : TypeEpEnum.ADD);
  }

  get typeForm(){
    return TypeDialogEnum.FORM;
  }

  get typeConfirm(){
    return TypeDialogEnum.CONFIRM;
  }

  get typeError(){
    return TypeDialogEnum.ERROR;
  }

  get typeInfo(){
    return TypeDialogEnum.INFO;
  }

  getErrorUrl( code: string ) {
    this.urlImgError = BaseUtilities.getUrlErrorDialogByCode( code );
  }

  onImageError( code: string ) {
    this.getErrorUrl( code );
  }

  public accept() {
    switch (this.type()) {
      case TypeDialogEnum.CONFIRM:
        this.objDataOutput = this.baseOkGetObjOutput( this.editData().entity );
        break;

      case TypeDialogEnum.FORM: {
        const formData = this.getEditData()?.() ?? this.editData();
        this.objDataOutput = this.baseOkGetObjOutput( formData );
        break;
      }
        
      case TypeDialogEnum.ERROR:
      case TypeDialogEnum.INFO:
        this.objDataOutput = this.baseOkGetObjOutput( undefined );
        break;

      default:
        break;
    }

    this.close( this.objDataOutput );
  }

  private getObjOutput( message: CloseDialogModalEnum, data: any ) {
    return BaseUtilities.setObjOutputDialog( message, data, this.subTypeDialog );
  }

  private baseOkGetObjOutput( data: any ) {
    return this.getObjOutput( CloseDialogModalEnum.OK, data );
  }

  private baseCancelGetObjOutput( data: any ) {
    return this.getObjOutput( CloseDialogModalEnum.CANCEL, data );
  }

  public reject() {
    switch (this.type()) { 
      case TypeDialogEnum.CONFIRM:
      case TypeDialogEnum.FORM:
        this.objDataOutput = this.baseCancelGetObjOutput( this.editData().entity );
        break;
        
      case TypeDialogEnum.ERROR:
      case TypeDialogEnum.INFO:
        this.objDataOutput = this.baseCancelGetObjOutput( undefined );
        break;

      default:
         break;
    }

    this.close( this.objDataOutput );
  }

  private close(obj: BaseObjOutputDialogInterface) {
    this.dialogRef.close( obj );
  }
}